// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"eec12403","631":"eec12403","644":"c49a9e95","737":"eec12403"}[chunkId] + ".chunk.css";
};